import React, { Component } from 'react';
import EffectParameterSlider from './EffectParameterSlider.js';

class EQ3Effect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            effect: props.effect,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.state.effect = nextProps.effect;
        return true;
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.state.effect.isEnabled();
    }

    render() {
        let className = this.props.automation !== undefined ?
            'enabled effect tall-effect effect-automation' :
            this.state.effect.isEnabled() ? 'tall-effect effect enabled' :
            'effect disabled';
        return (
            <div>
              {!this.isEnabled() ? '' :
                <div>
                  <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Low'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.lowParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={0.1}
                        max={10}
                        min={-10}
                        />
                      <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Mid'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.midParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={0.1}
                        max={10}
                        min={-10}
                        />
                      <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='High'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.highParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={0.1}
                        max={10}
                        min={-10}
                        />
                      <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Low Frequency'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.lowFrequencyParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={10}
                        max={400}
                        min={0}
                        />
                      <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='High Frequency'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.highFrequencyParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={10}
                        max={10000}
                        min={1000}
                        />
                 </div>} 
            </div>
        );
    }
}

export default EQ3Effect;
